import React, { useState, useEffect } from 'react';
import Card from '../../Components/Card/Card';
import CardHeader from '../../Components/Card/CardHeader';
import CardBody from '../../Components/Card/CardBody';
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import $ from 'jquery';
import 'jquery-confirm';
import * as _ from 'lodash';
import { api } from 'axiosConfig';


export default function Label(props: any) {
    const [inputValue, setInputValue] = useState<string>('');
    const [tags, setTags] = useState<string[]>([]);
    const tempTags = [...tags];
    const mapAllDataInTags = (data) => (data?.data?.map(item => item.name) ?? []);
    async function getAllDataFunc() {
        const url = process.env.REACT_APP_BASE_URL_API + "/api/v1/labels/getAll/50";
        await api.post(url, {})
            .then((res) => {
                let data = _.get(res, 'data', {});
                if (data?.status === 1 && data.hasOwnProperty('data')) {
                    // Hey! sonarqube, Please ignore this code
                    // const allTags = data.data.map(item => item.name);
                    const allTags = mapAllDataInTags(data);
                    tempTags.push(...allTags);
                    setTags(tempTags);
                }
            })
            .catch((err) => {
                $.alert("Something went wrong, please try again later");
                console.error(err);
            });
    }
    useEffect(() => {
        getAllDataFunc();
    }, []);
    // Hey! sonarqube, Please ignore this code
    // useEffect(async () => {
    //     const url = process.env.REACT_APP_BASE_URL_API + "/api/v1/labels/getAll/50";
    //     await api.post(url, {})
    //         .then((res) => {
    //             let data = _.get(res, 'data', {});
    //             if (data && data.status === 1 && data.hasOwnProperty('data')) {
    //                 const allTags = data.data.map(item => item.name);
    //                 tempTags.push(...allTags);
    //                 setTags(tempTags);
    //             }
    //         })
    //         .catch((err) => {
    //             $.alert("Something went wrong, please try again later");
    //             console.error(err);
    //         });
    // }, []);

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    const handleInputKeyPress = (e) => {
        if (e.key === 'Enter') {
            if (inputValue && inputValue !== '') {
                const newTags = inputValue.split(',').map((tag) => tag.trim());
                setTags((prevTags) => [...prevTags, ...newTags]);
                setInputValue('');
            }

        }
    };

    const handleTagCloseClick = (index) => {
        setTags((prevTags) => {
            const updatedTags = [...prevTags];
            updatedTags.splice(index, 1);
            return updatedTags;
        });
    };

    const assignLabels = () => {

    }

    return (
        <Card>
            <CardHeader color="info">
                <div className="d-flex align-items-center justify-content-between">
                    <h4 className="text-center">Labels</h4>
                    <button className='btn btn-primary' onClick={assignLabels}>Assign Labels</button>
                </div>
            </CardHeader>
            <CardBody>
                <TextField
                    style={{ width: '100%' }}
                    className="form-control"
                    label="Label Name"
                    value={inputValue}
                    onChange={handleInputChange}
                    onKeyPress={handleInputKeyPress}
                />
                <br />
                <br />
                <div>
                    {tags.map((tag, index) => (
                        <span key={"tags" + index} className="tag">
                            <Chip label={tag} onDelete={handleTagCloseClick} color="primary" />&nbsp;
                        </span>
                    ))}
                </div>
            </CardBody>
        </Card>

    )
}